import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { setToastSink } from "@/lib/api";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((msg, type = "default") => {
    const id = Math.random().toString(36).slice(2);
    setToasts((p) => [...p, { id, msg, type }]);
    setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), 4500);
  }, []);

  const toast = {
    info: (m) => push(m),
    success: (m) => push(m, "success"),
    error: (m) => push(m, "error"),
    warning: (m) => push(m, "warning"),
  };

  // Let the axios interceptor raise toasts for unhandled network/5xx
  // failures (see lib/api.js → surfaceGlobalError).
  useEffect(() => {
    setToastSink((m) => push(m, "error"));
    return () => setToastSink(null);
  }, [push]);

  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div className="toast-stack" data-testid="toast-stack">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`} data-testid="toast-item">
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
